/**
 * What stands in for a plain space inside the backend's initiative and category names, written
 * as escapes on purpose — all of it is invisible or unrenderable in an editor:
 *
 * - `\u00a0` no-break space (as in `Premium\u00a0(Incl. AI)`), `\u202f` narrow no-break space
 *   and `\u2007` figure space — sent as-is by the backend;
 * - `\ufffd` the replacement character. The same no-break space also arrives as a lone `0xa0`
 *   byte, which is not valid UTF-8, so unpacking the response turns it into `\ufffd` — the
 *   diamond seen in `Premium\ufffd(Incl. AI)`. Fixing the encoding is the backend's side of it;
 *   until then the name is only readable if this stands in for the space it used to be.
 */
const SPACE_SUBSTITUTES = /[\u00a0\u202f\u2007\ufffd]/g

/**
 * Replaces the above with plain spaces.
 *
 * Two things go wrong without it: the same name arriving once with a no-break space and once
 * without splits into two buckets that look identical on a chart, and a label carrying one can
 * never wrap, so it stretches its axis.
 */
export const normalizeSpaces = (value: string): string => value.replace(SPACE_SUBSTITUTES, ' ')
